import React from 'react';
import ModuleEdit from '../../Module/Edit';
import { useMessageManagerProvider } from '../../../../../../../context/messageManager';
import ImageModuleEndOfStatement from './ImageModule';
import TabsNavigation from '../Navigation';

function EndOfStatement() {
  const { state } = useMessageManagerProvider();

  const { selected } = state.step2.endOfStatement;

  return (
    <div className="grid grid-cols-[45%,1fr] gap-x-[20px]">
      <div className="min-h-full grid grid-rows-[auto,1fr]">
        <TabsNavigation />
        <div className="bg-white border py-[20px] px-[30px]">
          <ImageModuleEndOfStatement className="w-full" />
        </div>
      </div>
      <div className="bg-white grid border">
        {selected?.id ? (
          <ModuleEdit tab={1} />
        ) : (
          <div className="text-center self-center justify-center">
            <div className="text-primary mb-[15px] text-xl font-bold">Select a tab to begin editing</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default EndOfStatement;
